var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckpointHarmony(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8697 25.0616C29.1617 29.7455 27.9209 33.1686 24.0008 33.1686C20.0808 33.1686 18.7124 28.8709 19.1813 25.0616C19.6479 21.2716 22.1216 17.1855 23.9727 14.8455C23.9872 14.8272 24.0142 14.8277 24.0283 14.8462C25.855 17.2561 28.374 20.6287 28.8697 25.0616Z",
    fill: "#C42CE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0419 18.0437C14.959 18.2815 17.3423 18.5888 19.7014 19.469C18.9369 21.1518 18.384 23.0917 18.0914 25.2155C17.6722 28.2596 18.2486 30.9327 19.9105 32.3176C18.6614 31.4725 17.5027 30.2344 16.5825 28.9826C14.3176 25.9012 13.1912 21.1433 13.0001 18.082C12.9987 18.0597 13.0197 18.0409 13.0419 18.0437Z",
    fill: "#C42CE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9581 18.0442C33.041 18.2821 30.6577 18.5894 28.2986 19.4695C29.0631 21.1523 29.616 23.0922 29.9086 25.216C30.271 27.8481 29.8835 30.3025 28.6993 31.8721C29.7135 31.0653 30.6489 30.0287 31.4175 28.9832C33.6824 25.9017 34.8088 21.1438 34.9999 18.0825C35.0013 18.0603 34.9803 18.0414 34.9581 18.0442Z",
    fill: "#C42CE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckpointHarmony);
export default __webpack_public_path__ + "static/media/CheckpointHarmony.ea5631d84fb1f9bdfe8fcaa690c59fcb.svg";
export { ForwardRef as ReactComponent };